import styled from 'styled-components'

export const StyledInput = styled.input`
  display: none;
`
